import { stdObject } from "../../../data/types/stdObject";
import { convertDictData } from "../../../utils/convertDictData";

export default function DictionaryTable({ label, data }: stdObject) {
  let dictData: stdObject = convertDictData(data);
  return "data" in dictData && Object.keys(dictData.data).length > 0 ? (
    <div style={{ padding: 5 }}>
      {label !== "" && <div className="inputLabel">{label}</div>}
      <table className="dictTable">
        <tbody>
          {Object.keys(dictData.data).map((e: string, index: number) => (
            <tr key={index}>
              <td valign="top">
                <b>{e}</b>
              </td>
              <td>{dictData.data[e].name}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <></>
  );
}
